import React from 'react';
import { Field, reduxForm } from 'redux-form'
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { renderField, validate } from '../../helpers/validation.helper';

const ResetPasswordForm = props => {
    const { handleSubmit, email, errors } = props;

    return (
        <div>
            <div className="container-fluid reset-password">
                <div className="row">
                    <div className="col-lg-4 mx-auto">
                        <p className="text-white text-center">Parola temporară a fost trimisă la adresa de email {email}</p>
                        <div className="error-holder">
                            {errors.error}
                        </div>
                        <div className="col-lg-12">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-12">           
                                        <Field
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder="Email"
                                            component={renderField}
                                        />
                                        <Field
                                            id="tempPassword"
                                            name="tempPassword"
                                            type="password"
                                            placeholder="Parola temporară"
                                            component={renderField}
                                        />
                                        <Field
                                            id="password"
                                            name="password"
                                            type="password"
                                            placeholder="Parolă"
                                            component={renderField}
                                        />
                                        <Field
                                            id="passwordConfirm"
                                            name="passwordConfirm"
                                            type="password"
                                            placeholder="Confirmă parola"
                                            component={renderField}
                                        />
                                    <div className="reset-password-btn" >
                                        <Button className="btn-cinemap-blue" type="submit">Resetare parolă</Button>
                                    </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state, ownProps) => ({
    errors: state.user.errors
})


const form = reduxForm({
    form: 'resetPasswordForm',
    validate: validate('resetPasswordForm')
})

export default connect(mapStateToProps,{})(form(ResetPasswordForm));


// WEBPACK FOOTER //
// ./src/SHARED/components/forgotpassword/resetpasswordForm.js